import { z, uuidSchema } from '@kc3/validation';
import { baseEventFields } from './_base.js';
export const CampaignDeliveryJobSchema = z.object({
    type: z.literal('campaign.delivery.job'),
    ...baseEventFields,
    deliveryLogId: uuidSchema,
    ruleId: uuidSchema,
    campaignId: uuidSchema,
    audience: z.enum(['agent', 'client']),
    channel: z.enum(['email', 'sms', 'whatsapp', 'web']),
    eventType: z.string().min(1),
    recipientId: uuidSchema.nullable(),
    recipientAddress: z.string().nullable(),
    templateId: uuidSchema.nullable(),
    context: z.record(z.unknown()),
    correlationId: z.string().min(1),
    conversationId: uuidSchema.optional().nullable(),
    attempts: z.number().int().nonnegative().default(0),
    dedupeKey: z.string().min(1),
    whatsappTemplateName: z.string().optional(),
    smsDltTemplateId: z.string().optional(),
});
//# sourceMappingURL=campaign-notification.js.map